import { mapGetters, mapActions } from 'vuex'
import { listCarriers } from 'src/stubs/carriers'
import { convertToSlugArray } from 'src/filters'
import { uniq, isEmpty } from 'lodash'

export default {
  data() {
    let validatorRegion = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Tỉnh thành không được để trống'))
      } else {
        callback()
      }
    }
    let validatorKindFrom = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Loại quận huyện đi được để trống'))
      } else {
        callback()
      }
    }
    let validatorKindTo = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Loại quận huyện đến được để trống'))
      } else {
        callback()
      }
    }
    return {
      localDistrict: {
        id: 0,
        name: '',
        short_name: '',
        city_id: 0,
        code: '',
        kind_from: 0,
        kind_to: 0,
      },
      regionTable: 'regions',
      rules: {
        name: [
          {
            required: true,
            message: 'Bạn chưa nhập tên quận huyện',
            trigger: 'change',
          },
          {
            min: 5,
            max: 255,
            message: 'Tên quận huyện phải trong khoảng 5 đến 255 ký tự',
            trigger: 'change',
          },
        ],
        short_name: [
          {
            required: true,
            message: 'Bạn chưa nhập tên viết tắt',
            trigger: 'change',
          },
          {
            min: 2,
            max: 255,
            message:
              'Tên quận huyện viết tắt phải trong khoảng 2 đến 255 ký tự',
            trigger: 'change',
          },
        ],
        city_id: [
          { required: true, validator: validatorRegion, trigger: 'change' },
        ],
        code: [
          {
            required: true,
            message: 'Bạn chưa nhập mã bưu chính ',
            trigger: 'change',
          },
          {
            min: 1,
            max: 255,
            message: 'Mã bưu chính  phải trong khoảng 1 đến 255 ký tự',
            trigger: 'change',
          },
        ],
        kind_from: [
          { required: true, validator: validatorKindFrom, trigger: 'change' },
        ],
        kind_to: [
          { required: true, validator: validatorKindTo, trigger: 'change' },
        ],
      },
      listCarriers: listCarriers,
      defaultCarriers: {
        vtp: false,
        vnp: false,
        ghn: false,
        ghnv3: false,
        ghtk: false,
        njv: false,
        hbb: false,
        kerry: false,
        spl: false,
        supership: false,
        hola: false,
        snappy: false,
        nhattin: false,
        ems: false
      },
      dataCarriers: {
        vtp: {},
        vnp: {},
        ghn: {},
        ghnv3: {},
        ghtk: {},
        njv: {},
        hbb: {},
        kerry: {},
        spl: {},
        supership: {},
        hola: {},
        snappy: {},
        nhattin: {},
        shopee: {},
        jnt: {},
        ems: {}
      },
      checkedCarrier: false,
      submitting: false,
      mapNames: [],
      options: [],
      isUpdating: false,
    }
  },
  computed: {
    ...mapGetters('city', ['city', 'cities']),
    ...mapGetters('district', ['districtKind']),
    ...mapGetters('carrier', ['carriers']),
  },
  methods: {
    ...mapActions('city', ['getCity', 'getAllCity']),
    ...mapActions('district', ['getDistrictKind']),
    ...mapActions('carrier', ['getAllCarriers']),
    pushCarrier(carrier) {
      this.dataCarriers[carrier.short_name] = {
        id: carrier.id,
        kind_to: 0,
        kind_from: 0,
      }
    },
    newDistrict() {
      this.localDistrict = {
        id: 0,
        name: '',
        short_name: '',
        city_id: 0,
        code: '',
        kind_from: 0,
        kind_to: 0,
      }
    },
    handleChange(newValue) {
      if (this.isUpdating) return
      const latestValue = newValue[newValue.length - 1] // Lấy giá trị mới nhất
      if (!latestValue) return
      if (isEmpty(latestValue) || !/[a-zA-Z0-9]/.test(latestValue)) {
        this.isUpdating = true
        // Loại bỏ giá trị không hợp lệ và cập nhật sau khi DOM đã render
        this.mapNames = newValue.slice(0, -1) // Lấy tất cả phần tử trừ phần tử cuối
        this.$nextTick(() => {
          this.isUpdating = false
        })
        return
      }
      const isNew = !this.options.some((opt) => opt.value === latestValue)

      if (isNew) {
        this.isUpdating = true
        const slugValue = convertToSlugArray(latestValue) // Chuyển đổi giá trị mới thành slug
        // Thay thế giá trị mới bằng slug trong mảng
        this.mapNames.splice(newValue.length - 1, 1, slugValue)
        this.mapNames = uniq(this.mapNames)
        // Thêm cả giá trị gốc và slug vào options
        this.$nextTick(() => {
          this.isUpdating = false // Tắt flag sau khi cập nhật xong
        })
      }
    },
  },
  mounted() {
    this.newDistrict()
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }
    if (!this.districtKind.length) {
      this.getDistrictKind({ limit: -1 })
    }
    if (!this.carriers.length) {
      this.getAllCarriers({ limit: -1 })
    }
  },
  watch: {
    localDistrict: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true,
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/district/mixins/index.js